import { Link, LinkProps } from 'react-router-dom';

/**
 * A styled Link component that uses the secondary color (#728C00)
 * 
 * This component wraps the react-router-dom Link component and applies
 * consistent styling with the secondary color scheme.
 */
export function StyledLink({ children, className = '', ...props }: LinkProps) {
  return (
    <Link
      {...props}
      className={`font-medium text-[#728C00] dark:text-[#728C00] hover:text-[#5b7000] dark:hover:text-[#5b7000] ${className}`}
    >
      {children}
    </Link>
  );
}

export default StyledLink;
